import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.a0k4/v',
    defaultMessage: 'Connected apps',
  },
  empty: {
    id: 'studio.+bZ7DX',
    defaultMessage: 'You haven’t logged in to any Appsemble apps yet.',
  },
  error: {
    id: 'studio.iNbH4x',
    defaultMessage: 'There was a problem loading the your connected apps.',
  },
  loading: {
    id: 'studio.cZZAAo',
    defaultMessage: 'Loading your connected apps…',
  },
  help: {
    id: 'studio.sBzEh+',
    defaultMessage:
      'This page lists all apps which have been connected to your account using a login method.',
  },
});
